export const GET_SETTINGS='GET_SETTINGS'
export const GET_SETTINGS_SUCCESS='GET_SETTINGS_SUCCESS'
export const GET_SETTINGS_ERROR='GET_SETTINGS_ERROR'

export const GetSettings = (data) => ({
    type: GET_SETTINGS,
    payload: data
})